
<template>
   <v-dialog
      v-model="showHelp"
      max-width="490"
    >
      <v-card class="pb-3">
        <v-toolbar color="green darken-3" dark>
        <v-toolbar-title class="headline">About Room Amenities</v-toolbar-title>
      </v-toolbar>

        <v-card-text class="ml-2 mt-3">
          Room Amenities can create and track user-defined room attributes for any room.<br><br>
          
          <ul>
          <li>Select an Amenity List.</li>
          <li>'Populate' List to begin.</li>
          <li>Record data for this room.</li>
          </ul><br>
          Search for rooms by their Room Amenities<br> 
          <ul><li>Menu > Search > Rooms > Amenities</li></ul>
          <br>
          Use
          <a class="redlink" href="https:\\interactivefloorplans.arizona.edu\amenities">Room Amenities</a> off the main menu to create a new list.<br><br>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-layout align-items-center>
          <v-btn color="green darken-1"
            flat="flat"
            @click.stop="setShowHelpRoomAmenities(false)"
          > OK
          </v-btn>
      </v-layout>
        </v-card-actions>

      </v-card>
    </v-dialog>

</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'HelpRoomAmenities',

  computed: {
      showHelp: {
          get () { return this.$store.state.ui.showHelpRoomAmenities },
          set (value) { this.setShowHelpRoomAmenities(false) }
      },
  },
  
  methods : {
      ...mapMutations(['setShowHelpRoomAmenities',]),
  },
}

</script>





// WEBPACK FOOTER //
// src/components/help/HelpRoomAmenities.vue